import React from 'react';

import { useQuery } from '@apollo/client/react';
import { MainView } from '@repo/ui/Views';
import { Card } from '@repo/ui/Card';
import { useAccount } from '@/hooks/useAccount';
import AccountSettingsTabNav from '../components/account/AccountSettingsTabNav';
import AccountOverview from '../components/account/AccountOverview';
import CompanyDetailsForm from '../components/account/CompanyDetailsForm';

import GET_ADDRESSES_FOR_ACCOUNT from '../gql/getAddressesForAccount.gql';

const ManageAccount = () => {
  const account = useAccount();

  const { loading, data, error, refetch } = useQuery(GET_ADDRESSES_FOR_ACCOUNT, {
    variables: {
      first: 1,
      id: account?.id,
    },
  });

  const accountAddress = data?.addressesForAccount?.edges[0]?.node;

  return (
    <MainView title={`Manage Account:  ${account.name}`} description={`ID: ${account.customerId} `}>
      <AccountSettingsTabNav />
      <AccountOverview account={account} />

      {loading ? (
        <Card title="Company details" loading={loading} />
      ) : error ? (
        <Card title="Company details" error={error} />
      ) : (
        <CompanyDetailsForm accountAddress={accountAddress} refetch={refetch} />
      )}
    </MainView>
  );
};

export default ManageAccount;
